module.exports = __webpack_public_path__ + "img/icn-local-pin.bb7d7f0f.svg";